document.addEventListener('change', function (e) {
  if (e.target && e.target.id === 'rs-toggle') {
    const variantId = e.target.getAttribute('data-variant-id');
    const isChecked = e.target.checked;

    if (isChecked) {
      // Aggiunge il Regalo Segreto al carrello
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(() => window.location.reload());
    } else {
      // Lo rimuove dal carrello
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      })
        .then(() => window.location.reload());
    }
  }
});